import { render, staticRenderFns } from "./PartnerEditPageIframe.vue?vue&type=template&id=3a73eb44&"
import script from "./PartnerEditPageIframe.vue?vue&type=script&lang=ts&"
export * from "./PartnerEditPageIframe.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports